import { type Sort, SortDirection } from 'generatedTypes/flight/models';

export const DEFAULT_SORT: Sort[] = [{ direction: SortDirection.DESC, field: 'startTime' }];

const RANGE_START_YEAR = 2020;

export const RANGE_INTERVAL: Interval = {
    end: new Date(),
    start: new Date(RANGE_START_YEAR, 0, 1)
};

export const TEST_ID = 'ReportsPage';
